import React, { useEffect, useState } from 'react';
import { IDocument } from '../Interfaces/IDocument';
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useGetDownloadedDocuments } from '../hooks/reactQuerys/DocumentQueries';
import { ILegalClient } from '../Interfaces/ILegalClient';
import {
  downloadCountSentence,
  formatDownloadTimestamp,
} from '../services/documentDownloads.service';

interface IProps {
  documentObject: IDocument;
  assignedLegalClients: ILegalClient[];
}

export const DocumentDownloaded: React.FC<IProps> = ({
  documentObject,
  assignedLegalClients,
}) => {
  const { downloadedDocuments, isLoadingDownloadedDocuments } =
    useGetDownloadedDocuments();

  const [uniquideIdContactArray, setUniquideIdContactArray] = useState<
    number[]
  >([]);

  useEffect(() => {
    if (downloadedDocuments) {
      const tmpArray = [
        ...downloadedDocuments
          .filter(document => document.idDocument === documentObject.idDocument)
          .map(document => document.idLegalClient),
      ];
      const unique = tmpArray.filter(
        (value, index, array) => array.indexOf(value) === index
      );
      setUniquideIdContactArray([...unique]);
    }
  }, [documentObject.idDocument, downloadedDocuments]);

  if (isLoadingDownloadedDocuments) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='30vh'
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!downloadedDocuments) {
    return <>Error</>;
  }

  return (
    <>
      <Typography>
        Das Dokument <i>{documentObject.FileName}</i>{' '}
        {downloadCountSentence(
          downloadedDocuments.filter(
            document => document.idDocument === documentObject.idDocument
          ).length
        )}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Mandant</TableCell>
              <TableCell>Frühster Download</TableCell>
              <TableCell>Spätester Download</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {uniquideIdContactArray.map(localIdContact => {
              const currentContact = assignedLegalClients.find(
                contact => contact.idLegalClient === localIdContact
              );
              const ownDownloaded = downloadedDocuments
                .filter(
                  document => document.idDocument === documentObject.idDocument
                )
                .filter(document => document.idLegalClient === localIdContact);

              return (
                <TableRow key={localIdContact}>
                  <TableCell>
                    {currentContact?.FirstName} {currentContact?.LastName}
                  </TableCell>
                  <TableCell>
                    {formatDownloadTimestamp(ownDownloaded[0]?.Timestamp)}
                  </TableCell>
                  <TableCell>
                    {formatDownloadTimestamp(
                      ownDownloaded[ownDownloaded.length - 1]?.Timestamp
                    )}
                  </TableCell>
                  <TableCell>{ownDownloaded.length}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Typography>
    </>
  );
};
